var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"casual-upload-header bg-grey"},[_c('h1',{staticClass:"my-1"},[_vm._v(_vm._s(_vm.$t('Send Files Securely To') + ' ' + _vm.recipientName + _vm.$t(' From ') + _vm.themeSettings.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }